import * as Yup from 'yup';

// add global method to check password strength 
Yup.addMethod(Yup.Schema, 'isPasswordStrong', function(options, errorMessage = 'password must me stronger') {
  return this.test('test-is-password-strong', errorMessage, function(value) {
    const {
      path,
      createError
    } = this

    let isStrong = true

    // if field optional
    if (typeof value === 'undefined') {
        return true
    }

    if (options?.minLowercase) {
      if (!/[a-z]/.test(String(value))) {
        isStrong = false
      }
    }
    if (options?.minUppercase) {
      if (!/[A-Z]/.test(String(value))) {
        isStrong = false
      }
    }
    if (options?.minNumbers) {
      if (!/\d/.test(String(value))) {
        isStrong = false
      }
    }
    if (options?.minSymbols) {
      if (!/[!£$%*#@]/.test(String(value))) {
        isStrong = false
      }
    }

    return (
      isStrong ||
      createError({
        path,
        message: errorMessage
      })
    )
  })
});

const validationShape = {
  first_name: Yup.string().required("First Name is Required!."),
  last_name: Yup.string().required("Last Name is Required!."),
  email: Yup.string().email("Must be a valid email").required("Email Address is Required!."),
  confirm_email: Yup.string().email("Must be a valid email").oneOf([Yup.ref("email")], "Email Address is not matched!").required("Confirm Email Address is Required!."),
  school: Yup.string().required("School is Required!."),
  // other_school: Yup.string().required("School name is Required!."),

  other_school: Yup.string().when("school", {
    is: "other",
    then: () => Yup.string().required("School name is Required!."),
    otherwise: () => Yup.string().optional(),
  }),

  password: Yup.string()
    .required("Password is Required!.")
    .min(8, 'Password is too short - should be 8 characters minimum.')
    .isPasswordStrong({
      minUppercase: 1,
      minLowercase: 1,
      minNumbers: 1,
      minSymbols: 1
    }, 'password should contain at least 1 lower case letter, 1 upper case letter, 1 digit and 1 special character ( @ ! £ $ % * # )')
}

export const registerSchema = Yup.object().shape(validationShape);
